import { useEffect, useLayoutEffect, useState } from 'react';
import { useWindowEvent } from '@hooks/use-is-window';

const useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

const isBreakpoint = (breakpoint: number) => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return window.matchMedia(`(min-width: ${breakpoint}px)`).matches;
};

export const useIsBreakpoint = (breakpoint: number) => {
  const [isMatch, setIsMatch] = useState<Maybe<boolean>>(undefined);

  useWindowEvent(
    'resize',
    () => {
      setIsMatch(isBreakpoint(breakpoint));
    },
    100
  );

  useIsomorphicEffect(() => setIsMatch(isBreakpoint(breakpoint)), []);

  return isMatch;
};
